import React from "react";
import { Pricing } from "./landing/business-case/calculator";
import PricingHero from "./landing/pricing/PricingHero";
import WaysToWork from "./landing/pricing/WaysToWork";
import PlanTable from "./landing/pricing/PlanTable";
import Estimator from "./landing/pricing/Estimator";
import PricingPromise from "./landing/pricing/PricingPromise";
import IncludedGrid from "./landing/pricing/IncludedGrid";
import { LeadFormProvider } from "./landing/lead-form/LeadFormProvider";

type Props = {
  pricing: Pricing;
};

export default function PricingPage({ pricing }: Props) {
  return (
    <LeadFormProvider>
      <PricingHero pricing={pricing} />
      <WaysToWork />
      <PlanTable pricing={pricing} />
      <Estimator pricing={pricing} />
      <PricingPromise pricing={pricing} />
      <IncludedGrid pricing={pricing} />
    </LeadFormProvider>
  );
}
